import React, { FC, ReactElement, useMemo, useState } from 'react';
import { connect } from 'react-redux';
// Components
import Loader from '../../../components/loader';
import EditReservationWrapper from './editReservationWrapper';
import EditSelect, { RESET_VALUE } from '../../../components/profile/editSelect';
// Hooks
import { useUpdateRide } from '../../../core/services/rides';
import { useGetPolicies } from '../../../core/services/policies';
// Resources
import { EditRideInput, GetPoliciesOutput, PickerOption, Ride } from '../../../core/apiTypes';
import { PropsFromModal } from '../../../components/modals/createModalHOC';
import { stringsRes } from '../../../resources/strings';

interface EditReservationCostCenterProps extends PropsFromModal {
    reservation: Ride;
}

const EditReservationCostCenter: FC = (props: EditReservationCostCenterProps): ReactElement => {
    const { reservation, onRequestClose } = props;

    // const isPro = isRidePro(reservation);

    const [selectedCostCenter, setSelectedCostCenter] = useState<string>(null);

    const updateRide = useUpdateRide();
    const { data: groupPolicyDatas, isFetching } = useGetPolicies<GetPoliciesOutput>({
        enabled: !!reservation.group?.uuid,
        variables: { groups: [reservation?.group?.uuid] },
    });
    const groupPolicy = groupPolicyDatas?.group?.[0];
    const { cost_centers: costCenters, cost_center_mandatory: costCenterMandatory } = groupPolicy || {};
    const defaultCostCenter = costCenters?.find((cc) => cc.id === reservation.cost_center?.id);

    const onSelectCostCenter = (costCenterId: string) => {
        setSelectedCostCenter(costCenterId);
    };

    const onConfirm = (): void => {
        const payload: EditRideInput = {
            id: reservation.id,
            cost_center_id: selectedCostCenter || null,
        };

        updateRide.mutate(payload, {
            onSuccess: () => {
                onRequestClose();
            },
        });
    };

    const costCenterOptions: PickerOption[] = useMemo(
        () => costCenters?.map((cc) => ({ value: cc.id, label: cc.name })),
        [costCenters],
    );

    const renderCostCenter = (): JSX.Element | JSX.Element[] => {
        if (isFetching) {
            return <Loader />;
        }

        return (
            <EditSelect
                label={stringsRes.profile.costCenter}
                items={costCenterOptions}
                initialValue={defaultCostCenter?.id ?? (costCenterMandatory ? '' : RESET_VALUE)}
                onSelect={onSelectCostCenter}
                noReset={costCenterMandatory}
                resetLabel={stringsRes.profile.costCenterNone}
            />
        );
    };

    return (
        <EditReservationWrapper
            {...props}
            description={
                costCenterMandatory ? stringsRes.profile.costCenterMandatory : stringsRes.profile.costCenterSelect
            }
            onConfirm={onConfirm}
            disableConfirm={costCenterMandatory && !selectedCostCenter}
            loadingConfirm={updateRide.isLoading}
        >
            {renderCostCenter()}
        </EditReservationWrapper>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditReservationCostCenter);
